import { Box, Container, Grid, useMediaQuery } from "@material-ui/core"
import React, { useEffect, useState } from "react"
import Module from "../components/Module"
import VisibilitySensor from "../animations/VisibilitySensor"
import Text from "../components/Text"
import { detectAlpha2Country } from "@src/utils/country"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { getKeys } from "@src/utils/dictionary"
import countries from "../site/countries"

const useStyles = makeStyles(theme => ({
  scrollContainer: {
    overflowY: "scroll",
    overflowX: "hidden",
    fontSize: "14px",
    maxHeight: "330px",
    boxShadow: "inset 0 -2px 0 0 rgba(0,0,0,.05)",
    [theme.breakpoints.up("md")]: {
      fontSize: "18px",
    },

    "&::-webkit-scrollbar": {
      width: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: "4px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  tableHeader: {
    width: "100%",
    fontSize: "14px",
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    marginBottom: "10px",
    color: theme.palette.primary.main,
    fontWeight: 600,
    [theme.breakpoints.up("md")]: {
      fontSize: "18px",
    },
  },
}))

const IssuesDetailsModule = ({ title, product, kiosk_sales_date_visible }) => {
  const classes = useStyles()
  const theme = useTheme()
  const [issues, setIssues] = useState([])
  const [labels, setLabels] = useState(null)
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  useEffect(() => {
    const fetchData = async () => {
      let response = await fetch(
        `${
          process.env.GATSBY_ISSUES_PAGE_PRODUCTS
        }${detectAlpha2Country()}&productCode=${
          product?.field_value?.code
        }&skipVisibility=true`
      )
      response = await response.json()

      setIssues(response?.[0]?.issues)
    }
    const fetchLabels = async () => {
      setLabels(
        await getKeys({
          date: "product.issues.table.column.date",
          description: "product.issues.table.column.description",
          num: "product.issues.table.column.number",
        })
      )
    }

    fetchData()
    fetchLabels()
  }, [])

  const formatDate = date => {
    if (date) {
      const locale =
        countries.find(
          el => el.country.toLowerCase() === detectAlpha2Country()
        ) || "en-GB"
      return new Date(date).toLocaleDateString(locale, {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    }

    return "-"
  }

  return (
    <Module>
      <VisibilitySensor>
        <Container>
          {(issues || []).length > 0 && (
            <Grid
              container
              alignItems="center"
              spacing={4}
              style={{ padding: "0 20px" }}
            >
              <Grid item xs={12} md={4}>
                <Box paddingY={4}>
                  <Text
                    align={isMobile ? "center" : "left"}
                    variant="titleXXXL"
                    component="h3"
                    weight="bold"
                    overline
                  >
                    {title.field_value}
                  </Text>
                </Box>
              </Grid>

              <Grid item xs={12} md={8}>
                <Box className={classes.tableHeader}>
                  <Grid container>
                    <Grid item xs={2}>
                      {labels?.num}
                    </Grid>
                    <Grid
                      item
                      xs={
                        kiosk_sales_date_visible?.field_value === "show"
                          ? 7
                          : 10
                      }
                    >
                      {labels?.description}
                    </Grid>
                    {kiosk_sales_date_visible?.field_value === "show" && (
                      <Grid item xs={3}>
                        {labels?.date}
                      </Grid>
                    )}
                  </Grid>
                </Box>
                <Box className={classes.scrollContainer}>
                  {(issues || []).map((el, index) => (
                    <Box key={index} mb={2}>
                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          {el.position}
                        </Grid>
                        <Grid
                          item
                          xs={
                            kiosk_sales_date_visible?.field_value === "show"
                              ? 7
                              : 10
                          }
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: el?.title,
                            }}
                          />
                        </Grid>
                        {kiosk_sales_date_visible?.field_value === "show" && (
                          <Grid item xs={3}>
                            {formatDate(el?.issued_at)}
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  ))}
                </Box>
              </Grid>
            </Grid>
          )}
        </Container>
      </VisibilitySensor>
    </Module>
  )
}

export default IssuesDetailsModule
